"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("../Text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FieldItem = function FieldItem(_ref) {
  var type = _ref.type,
      label = _ref.label,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: {
      marginBottom: '30px'
    }
  }, label && /*#__PURE__*/_react["default"].createElement("label", {
    style: {
      display: 'block',
      marginBottom: '10px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    type: type
  }, label)), children);
};

var _default = FieldItem;
exports["default"] = _default;